"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const InputLabel = ({ className, ...props }) => {
    return ((0, jsx_runtime_1.jsx)("label", { className: (0, classnames_1.default)(className, 'hot-form__label'), ...props }));
};
exports.default = InputLabel;
